<div class="mechanic-hours-container">
  <div class="date-range">
    <h2 class="mechanic-hours-header">
      {{ weeklyScheduleMX.mechaniceHrsReview }}:
    </h2>
    <div class="date-navigation">
      <nz-date-picker
        [nzDisabledDate]="disableNonMondays"
        (ngModelChange)="onDateChange($event)"
        [(ngModel)]="selectedDate"
        nzFormat="MM-dd-yyyy"
        class="nav-button_align"
      ></nz-date-picker>
      <button
        class="nav-button refresh-button nav-button_align"
        (click)="onRefresh()"
        nz-tooltip
        nzTooltipTitle="Refresh"
        >
        !
      </button>
      <input
        [(ngModel)]="searchText"
        (ngModelChange)="onSearch()"
        placeholder="Search by Employee"
        class="search-input"
        />
      </div>
      <div class="Totalcount">
        {{ totalSchedules }} {{ weeklyScheduleMX.records }}
      </div>
    </div>
    <div class="responsive-table-container">
      <div class="nz-table-container">
        <nz-table
          #crewTable
          [nzData]="crewWeeklyDetails"
          class="table table-striped"
          [nzFrontPagination]="true"
          >
          <thead>
            <tr>
              <th rowspan="2">{{ weeklyScheduleMX.employeeName }}</th>
              @for (day of days; track day) {
                <th
                  colspan="3"
                  [ngStyle]="{ color: '#4169E1' }"
                  >
                  {{ day }}
                </th>
              }
            </tr>

            <tr>
              @for (day of days; track day) {
                @if (day === 'Total') {
                  <th class="reg-cell header-bg">{{ weeklyScheduleMX.reg }}</th>
                  <th class="ot-cell header-bg">{{ weeklyScheduleMX.ot }}</th>
                  <th class="text-red header-bg">{{ weeklyScheduleMX.tot }}</th>
                } @else {
                  <th class="sch-cell header-bg">{{ weeklyScheduleMX.sch }}</th>
                  <th class="reg-cell header-bg">{{ weeklyScheduleMX.reg }}</th>
                  <th class="ot-cell header-bg">{{ weeklyScheduleMX.ot }}</th>
                }
              }
            </tr>
          </thead>
          @if (
            crewTable.data && crewTable.data.length > 0) {
            <tbody
              >
              @for (weeklyday of crewTable.data; track weeklyday) {
                <tr>
                  <td class="text-left">{{ weeklyday.EmployeeName }}</td>
                  @for (day of days; track day) {
                    @if (day === 'Total') {
                      <td class="reg-cell">
                        {{
                        getDayWeeklyReport(weeklyday, day, "Reg") | number : "1.2-2"
                        }}
                      </td>
                      <td class="ot-cell">
                        {{
                        getDayWeeklyReport(weeklyday, day, "OT") | number : "1.2-2"
                        }}
                      </td>
                      <td class="text-red">
                        {{
                        getDayWeeklyReport(weeklyday, day, "Total")
                        | number : "1.2-2"
                        }}
                      </td>
                    } @else {
                      <td class="sch-cell">
                        {{
                        getDayWeeklyReport(weeklyday, day, "Sch") | number : "1.2-2"
                        }}
                      </td>
                      <td class="reg-cell">
                        {{
                        getDayWeeklyReport(weeklyday, day, "Reg") | number : "1.2-2"
                        }}
                      </td>
                      <td class="ot-cell">
                        {{
                        getDayWeeklyReport(weeklyday, day, "OT") | number : "1.2-2"
                        }}
                      </td>
                    }
                  }
                </tr>
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="100%" class="loader-container">
                  @if (isLoading) {
                    <div class="loader"></div>
                  }
                  @if (!isLoading) {
                    <div class="no-available">
                      {{ weeklyScheduleMX.noDataFound }}
                    </div>
                  }
                </td>
              </tr>
            </tbody>
          }
        </nz-table>
      </div>
    </div>
    <div class="responsive-table-container">
      <div class="nz-table-container">
        <div class="equiv-men">{{ weeklyScheduleMX.equiveMen }}:</div>
        <table class="equive-table text-center">
          <thead>
            <tr>
              <h6></h6>
              @for (day of days; track day) {
                <th class="sch-header">{{ weeklyScheduleMX.sch }}</th>
                <th class="act-header">{{ weeklyScheduleMX.act }}</th>
                &nbsp;
              }
            </tr>
            &nbsp;
          </thead>
          <tbody>
            <tr>
              <h5>{{ weeklyScheduleMX.routine }}:</h5>
              @for (day of days; track day) {
                <td class="text-green">
                  {{ getRoutineReport(day, "SchRout") | number : "1.2-2" }}
                </td>
                <td class="text-brown">
                  {{ getRoutineReport(day, "Rout") | number : "1.2-2" }}
                </td>
                &nbsp;
              }
            </tr>
            <span>&nbsp;</span>
            <tr>
              <h5>{{ weeklyScheduleMX.project }}:</h5>
              @for (day of days; track day) {
                <td class="text-green">
                  {{ getProjectReport(day, "SchProj") | number : "1.2-2" }}
                </td>
                <td class="text-brown">
                  {{ getProjectReport(day, "Proj") | number : "1.2-2" }}
                </td>
                &nbsp;
              }
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
